import { useState, useEffect, createContext } from "react";
import Home from "@pages/Home.page";
import Header from "@components/common/Header.component";
import Footer from "@components/common/Footer.component";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import EmeraldCity from "@pages/product/EmeraldCity.product";
import Gangstabet from "@pages/product/Gangstabet.product";
import WalletModal from "@components/modal/WalletModal.component";
import Toaster from "@components/common/toaster/Toaster.component";
import toasterService from "@components/common/toaster/ToasterService.component";

//Test Code
import IllustrationHome from "@components/illustration/Home.component";

export default function App() {
  const [toasterList, setToasterList] = useState([]);
  useEffect(() => {
    toasterService.get().subscribe((data: any) => {
      setToasterList(data);
    });
  });
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/emerald-city" element={<EmeraldCity />} />
        <Route path="/gangstabet" element={<Gangstabet />} />
        <Route path="/mint" element={<IllustrationHome />} />
      </Routes>
      <Footer backgroundColor="black" />
      <Toaster position="bottom-right" autoDelete toastList={toasterList} />
    </BrowserRouter>
  );
}
